import { Link } from 'react-router-dom';
import styles from './LegalPage.module.css';

export function PrivacyPage() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Link to="/" className={styles.backLink}>← Back to Home</Link>
        
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.lastUpdated}>Last updated: January 1, 2026</p>

        <section className={styles.section}>
          <h2>1. Introduction</h2>
          <p>
            OmenSystems ("we", "our", or "us") operates the Omen SEO service 
            at seo.omensystems.com. This Privacy Policy explains how we collect, use, 
            disclose, and safeguard your information when you use our service.
          </p>
        </section>

        <section className={styles.section}>
          <h2>2. Information We Collect</h2>
          <h3>Account Information</h3>
          <p>
            When you create an account, we collect your email address and authentication 
            credentials through our authentication provider, Clerk.
          </p>
          <h3>Website Data</h3>
          <p>
            We collect and analyze publicly available information from websites you submit 
            for scanning, including security headers, SSL certificates, and page content.
          </p>
          <h3>Usage Data</h3>
          <p>
            We automatically collect information about how you interact with our service, 
            including pages visited, features used, and scan history.
          </p>
        </section>

        <section className={styles.section}>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain our service</li>
            <li>Process your website scans and generate reports</li>
            <li>Send you service-related communications</li>
            <li>Process payments and manage subscriptions</li>
            <li>Improve and optimize our service</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>4. Data Retention</h2>
          <p>
            We retain your data for as long as your account is active or as needed to 
            provide services. Scan data retention varies by subscription tier. You may 
            request deletion of your data at any time.
          </p>
        </section>

        <section className={styles.section}>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect 
            your personal information, including encryption in transit and at rest, 
            access controls, and regular security assessments.
          </p>
        </section>

        <section className={styles.section}>
          <h2>6. Third-Party Services</h2>
          <p>We use the following third-party services:</p>
          <ul>
            <li>Clerk - Authentication</li>
            <li>Dodo Payments - Payment processing</li>
            <li>Amazon Web Services - Infrastructure</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>7. Your Rights</h2>
          <p>
            Depending on your location, you may have rights including access to your data, 
            correction of inaccurate data, deletion of your data, and data portability. 
            Contact us to exercise these rights.
          </p>
        </section>

        <section className={styles.section}>
          <h2>8. Contact Us</h2>
          <p>
            For privacy-related inquiries, contact us at{' '}
            <a href="mailto:privacy@omensystems.com">privacy@omensystems.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
